/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// clang-format off
export {
  defineComponent as ÉµdefineComponent,
  defineDirective as ÉµdefineDirective,
  definePipe as ÉµdefinePipe,
  defineNgModule as ÉµdefineNgModule,
  detectChanges as ÉµdetectChanges,
  renderComponent as ÉµrenderComponent,
  ComponentType as ÉµComponentType,
  DirectiveType as ÉµDirectiveType,
  RenderFlags as ÉµRenderFlags,
  directiveInject as ÉµdirectiveInject,
  injectElementRef as ÉµinjectElementRef,
  injectTemplateRef as ÉµinjectTemplateRef,
  injectViewContainerRef as ÉµinjectViewContainerRef,
  injectChangeDetectorRef as ÉµinjectChangeDetectorRef,
  injectAttribute as ÉµinjectAttribute,
  PublicFeature as ÉµPublicFeature,
  InheritDefinitionFeature as ÉµInheritDefinitionFeature,
  NgOnChangesFeature as ÉµNgOnChangesFeature,
  NgModuleType as ÉµNgModuleType,
  CssSelectorList as ÉµCssSelectorList,
  markDirty as ÉµmarkDirty,
  NgModuleFactory as ÉµNgModuleFactory,
  NC as ÉµNC,
  C as ÉµC,
  E as ÉµE,
  NH as ÉµNH,
  NM as ÉµNM,
  NS as ÉµNS,
  Ee as ÉµEe,
  L as ÉµL,
  T as ÉµT,
  V as ÉµV,
  Q as ÉµQ,
  Qr as ÉµQr,
  d as Éµd,
  P as ÉµP,
  b as Éµb,
  i1 as Éµi1,
  i2 as Éµi2,
  i3 as Éµi3,
  i4 as Éµi4,
  i5 as Éµi5,
  i6 as Éµi6,
  i7 as Éµi7,
  i8 as Éµi8,
  iV as ÉµiV,
  pb1 as Éµpb1,
  pb2 as Éµpb2,
  pb3 as Éµpb3,
  pb4 as Éµpb4,
  pbV as ÉµpbV,
  f0 as Éµf0,
  f1 as Éµf1,
  f2 as Éµf2,
  f3 as Éµf3,
  f4 as Éµf4,
  f5 as Éµf5,
  f6 as Éµf6,
  f7 as Éµf7,
  f8 as Éµf8,
  fV as ÉµfV,
  cR as ÉµcR,
  cr as Éµcr,
  qR as ÉµqR,
  ql as Éµql,
  e as Éµe,
  p as Éµp,
  pD as ÉµpD,
  rS as ÉµrS,
  a as Éµa,
  s as Éµs,
  sm as Éµsm,
  sp as Éµsp,
  sa as Éµsa,
  cp as Éµcp,
  t as Éµt,
  v as Éµv,
  st as Éµst,
  ld as Éµld,
  Pp as ÉµPp,
  ComponentDef as ÉµComponentDef,
  DirectiveDef as ÉµDirectiveDef,
  PipeDef as ÉµPipeDef,
  whenRendered as ÉµwhenRendered,
  iA as ÉµiA,
  iEM as ÉµiEM,
  iI1 as ÉµiI1,
  iI2 as ÉµiI2,
  iI3 as ÉµiI3,
  iI4 as ÉµiI4,
  iI5 as ÉµiI5,
  iI6 as ÉµiI6,
  iI7 as ÉµiI7,
  iI8 as ÉµiI8,
  iIV as ÉµIV,
  iM as ÉµiM,
  I18nInstruction as ÉµI18nInstruction,
  I18nExpInstruction as ÉµI18nExpInstruction,
} from './render3/index';
export {NgModuleDef as ÉµNgModuleDef} from './metadata/ng_module';
export {
  sanitizeHtml as ÉµsanitizeHtml,
  sanitizeStyle as ÉµsanitizeStyle,
  sanitizeUrl as ÉµsanitizeUrl,
  sanitizeResourceUrl as ÉµsanitizeResourceUrl,
} from './sanitization/sanitization';
export {
  bypassSanitizationTrustHtml as ÉµbypassSanitizationTrustHtml,
  bypassSanitizationTrustStyle as ÉµbypassSanitizationTrustStyle,
  bypassSanitizationTrustScript as ÉµbypassSanitizationTrustScript,
  bypassSanitizationTrustUrl as ÉµbypassSanitizationTrustUrl,
  bypassSanitizationTrustResourceUrl as ÉµbypassSanitizationTrustResourceUrl,
} from './sanitization/bypass';
// clang-format on
